var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { PoseComponent, PoseParentContext } from './components/PoseComponent';
var posedFactory = function (_a) {
    var componentMap = _a.componentMap, createAnimatedComponent = _a.createAnimatedComponent, factoryConfig = __rest(_a, ["componentMap", "createAnimatedComponent"]);
    var posedComponentFactory = function (Component) { return function (poseConfig) {
        if (poseConfig === void 0) { poseConfig = {}; }
        return function (_a) {
            var _b = _a.withParent, withParent = _b === void 0 ? true : _b, props = __rest(_a, ["withParent"]);
            return !withParent || props.parentValues ? (<PoseComponent poseConfig={poseConfig} factoryConfig={factoryConfig} Component={Component} {...props}/>) : (<PoseParentContext.Consumer>
        {function (parentCtx) { return (<PoseComponent poseConfig={poseConfig} factoryConfig={factoryConfig} Component={Component} {...props} {...parentCtx}/>); }}
      </PoseParentContext.Consumer>);
        };
    }; };
    var posedComponent = function (Component) {
        return posedComponentFactory(Component ? createAnimatedComponent(Component) : undefined);
    };
    var posed = Object.keys(componentMap).reduce(function (acc, key) {
        var Component = componentMap[key];
        acc[key] = posedComponentFactory(Component);
        return acc;
    }, posedComponent);
    return posed;
};
export default posedFactory;
//# sourceMappingURL=posed.js.map